export default class MongoNotificationShowcaseInvitation {
  showcaseId = "";
  showcaseTitle = "";

  invitorId = "";
  invitorName = "";
  invitorLogoUrl = "";
}
